module.exports = __webpack_public_path__ + "img/cartillas-silabas-inversas-directas.2526cfaa.png";